export const defaultEventValue = {
  id: 0,
  title: 'event',
  trait: {id: -1, name: ''},
  operator: {id: -1, name: ''},
  value: '',
  predefinedValue: {id: -1, name: ''},
}
